var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoGame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.49,34.633H30.51c-7.371,0-13.367,5.997-13.367,13.367c0,7.371,5.997,13.367,13.367,13.367 c4.378,0,8.478-2.17,10.964-5.734h13.053c2.486,3.564,6.586,5.734,10.964,5.734c7.371,0,13.367-5.996,13.367-13.367 C78.857,40.629,72.861,34.633,65.49,34.633z M65.49,57.367c-3.346,0-6.46-1.812-8.13-4.728c-0.355-0.623-1.019-1.007-1.735-1.007 h-15.25c-0.717,0-1.379,0.384-1.736,1.007c-1.669,2.916-4.784,4.728-8.129,4.728c-5.165,0-9.367-4.202-9.367-9.367 s4.202-9.367,9.367-9.367h34.98c5.165,0,9.367,4.202,9.367,9.367S70.655,57.367,65.49,57.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.128,46H32.51v-2.618c0-1.104-0.896-2-2-2s-2,0.896-2,2V46h-2.618c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.618v2.618 c0,1.104,0.896,2,2,2s2-0.896,2-2V50h2.618c1.104,0,2-0.896,2-2S36.232,46,35.128,46z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.49,
    cy: 43.033,
    r: 2.785
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.872,
    cy: 48,
    r: 2.785
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.108,
    cy: 48,
    r: 2.785
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49,50.182c-1.536,0-2.785,1.249-2.785,2.785c0,1.535,1.249,2.784,2.785,2.784s2.785-1.249,2.785-2.784 C68.274,51.431,67.025,50.182,65.49,50.182z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGame);
export default __webpack_public_path__ + "static/media/video-game.c737aad5f1bedd7a543c1c198b8c26de.svg";
export { ForwardRef as ReactComponent };